<template>
	<div class="pages">
		<sub-ibox-title>
			<p slot="title">收银台订单详情</p>
		</sub-ibox-title>
		<section class="content">
			<ul class="promotion-ditail">
				<li class="fx fx-y-center"><p>微信头像</p>
					<div>
						<img :src="info.headimgurl | defultHeadPic" style="width: 50px; height: 50px;"/>
					</div>
				</li>
				<li class="fx fx-y-center"><p>微信昵称</p><div>{{info.nickname || '--'}}</div></li>
				<li class="fx fx-y-center"><p>使用门店</p><div>{{info.name}}</div></li>
				<li class="fx fx-y-center"><p>优惠金额</p><div>{{info.offer_money | filterMoney}} 元</div></li>
				<li class="fx fx-y-center"><p>支付金额</p><div>{{info.pay_money | filterMoney}} 元</div></li>
				<li class="fx fx-y-center"><p>合计金额</p><div>{{info.amount | filterMoney}} 元</div></li>
				<li class="fx fx-y-center"><p>创建时间</p><div>{{info.c_time | momentFmt}}</div></li>
				<li class="fx fx-y-center"><p>支付时间</p><div>{{info.pay_time | momentFmt}}</div></li>
				<li class="fx fx-y-center"><p>订单号</p><div>{{info.order_no}}</div></li>
				<li class="fx fx-y-center"><p>订单状态</p><div>{{info.status | filterOrderStatus}}</div></li>
				<li class="fx fx-y-center" v-if="info.refunds_time"><p>退款时间</p><div>{{info.refunds_time | momentFmt}}</div></li>
				<li class="fx fx-y-center" v-if="info.status==4 || info.status==5"><p>退款理由</p><div>{{info.refund_content || '--'}}</div></li>
				<li class="fx fx-y-center"><p>支付平台</p><div>{{info.pay_type | filterOsType}}支付</div></li>
				<li class="fx fx-y-center"><p>支付终端</p><div>{{info.os_type}}</div></li>
			</ul>
		</section>
	</div>
</template>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.content {
		border-top: none;
	}
	.promotion-ditail{
		li{
			padding: px-em(10px) 0;
		}
		p{
			width: px-em(280px);
		}
	}
</style>
<script>
	import {
		mapState,
		mapActions
	} from 'vuex'
	export default {
		name: 'ParRecordInfo',
		data() {
			return {
			}
		},
		mounted() {
			let id = this.$route.query.id
			if(!id) return this.$errorMsg('参数错误')
			this.handleGetCashierOrderInfo(id)
		},
		computed: {
			...mapState({
				info: state => state.payRecord.orderInfo
			})
		},
		/*
		 * 事件处理
		 */
		methods: {
			async handleGetCashierOrderInfo(id) {
				this.getCashierOrderInfo({id})
			},
			...mapActions(['getCashierOrderInfo']),
		},
	}
</script>


// WEBPACK FOOTER //
// PayRecordInfo.vue?9313054a